import { z } from "zod";
import { estadoSuscripcionSchema } from "./enums";
import { planSchema } from "./plan";

/**
 * Subscription data from database
 */
export const suscripcionDbSchema = z.object({
	id: z.coerce.number(),
	usuario_id: z.string(),
	plan_id: z.coerce.number(),
	estado: estadoSuscripcionSchema,
	periodo_inicio: z.string().nullable(),
	periodo_fin: z.string().nullable(),
	proveedor: z.string().optional(),
	proveedor_pago_id: z.string().nullable(),
	proveedor_cliente_id: z.string().nullable(),
	en_periodo_prueba: z.boolean().optional(),
	fecha_fin_prueba: z.string().nullable().optional(),
	plan_programado_id: z.coerce.number().nullable().optional(),
	tarjeta_ultimos_4: z.string().nullable().optional(),
	fecha_proximo_cobro: z.string().nullable().optional(),
	ciclo_facturacion: z.string().optional(),
	cancelar_al_fin_periodo: z.boolean().optional().nullable(),
	plan: planSchema.optional(),
});
export type SuscripcionDb = z.infer<typeof suscripcionDbSchema>;

/**
 * Combined subscription response (from GET /suscripcion)
 */
export const subscriptionResponseSchema = z.object({
	suscripcion: suscripcionDbSchema.nullable(),
});
export type SubscriptionResponse = z.infer<typeof subscriptionResponseSchema>;
